export const white = '#ffffff';
export const black = '#212731';

export const greyLightest = '#eff1f6';
export const greyLighter = '#d4dbe7';
export const greyLight = '#c5ceda';
export const grey = '#818b97';
export const grayDark = '#4d5866';
export const greyDarker = '#373f49';
export const greyDarkest = '#28313c';

export const greenLighter = '#83d9c8';
export const greenLight = '#59ccb5';
export const green = '#30bfa3';
export const greenDark = '#269982';
export const greenDarker = '#1d7362';

export const redLighter = '#ef9b95';
export const redLight = '#ea7a71';
export const red = '#e5594e';
export const redDark = '#b7473e';
export const redDarker = '#89352f';

export const yellowLighter = '#ffe5ab';
export const yellowLight = '#ffdc8f';
export const yellow = '#ffd373';
export const yellowDark = '#cca95c';
export const yellowDarker = '#997f45';

export const blueLighter = '#83d9c8';
export const blueLight = '#59ccb5';
export const blue = '#008fd9';
export const blueDark = '#269982';
export const blueDarker = '#1d7362';

export const orangeLighter = '#eec98e';
export const orangeLight = '#e9b768';
export const orange = '#e3a542';
export const orangeDark = '#b68435';
export const orangeDarker = '#886328';

export const neutral50 = '#c0c5cb';
export const neutral100 = '#d4dbe7';
export const neutral200 = '#a7aeb6';
export const neutral300 = '#c5ceda';
export const neutral400 = '#8e97a1';
export const neutral500 = '#818b97';
export const neutral600 = '#747d88';
export const neutral700 = '#373f49';
export const neutral800 = '#5a616a';
export const neutral900 = '#28313c';
